import { get } from 'lodash';

import Model from 'models';

const BooleanExperimentCampaign = class extends Model {
  get campaign() {
    return this._data.campaign;
  }

  get experimentIdentifier() {
    return this._data.experimentIdentifier;
  }

  get variation() {
    return get(this.campaign, ['variations', '0']);
  }

  get dynamicYieldIdentifiers() {
    return get(this.variation, ['payload', 'data']);
  }

  get status() {
    return this.campaign?.status;
  }

  get isExperimentActive() {
    return get(this.dynamicYieldIdentifiers, this.experimentIdentifier, false);
  }

  get experimentEngagementIdentifiers() {
    return {
      dyDecisionId: get(this.campaign, 'decisionId'),
      dyVariationId: get(this.variation, 'id'),
    };
  }
};

export default BooleanExperimentCampaign;
